import { FunctionComponent, ReactNode } from "react";

import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import { clearAuthenticatedUserContext, setAuthenticatedUserContext } from "../utils/appInsights";
import { msalConfig } from "./auth-config";

interface IAuthProviderProps {
  children: ReactNode;
}

const newMsalInstance = new PublicClientApplication(msalConfig);

// Listen for sign-in, sign-out, and initialize events and set active account and application insights context
newMsalInstance.addEventCallback((event: EventMessage) => {
  const authenticationResult = event.payload as AuthenticationResult;
  const account = authenticationResult?.account;

  if (event.eventType === EventType.LOGIN_SUCCESS && account) {
    newMsalInstance.setActiveAccount(account);
    setAuthenticatedUserContext(account.localAccountId);
  } else if (event.eventType === EventType.LOGOUT_START) {
    clearAuthenticatedUserContext();
  } else if (event.eventType === EventType.INITIALIZE_END) {
    const account = newMsalInstance.getActiveAccount() ?? newMsalInstance.getAllAccounts()[0];

    if (account) {
      newMsalInstance.setActiveAccount(account);
      setAuthenticatedUserContext(account.localAccountId);
    } else {
      clearAuthenticatedUserContext();
    }
  }
});

export const AuthProvider: FunctionComponent<IAuthProviderProps> = ({ children }: IAuthProviderProps) => {
  return <MsalProvider instance={newMsalInstance}>{children}</MsalProvider>;
};
